import { render, staticRenderFns } from "./DonationCancelled.vue?vue&type=template&id=5d78099c&"
import script from "./DonationCancelled.vue?vue&type=script&lang=js&"
export * from "./DonationCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports